import emailValidator from '@/utils/validators/email';

export const SEPARATOR_REGEX = /[,; \n]+/;

function parseEmails(input: string): string[] {
  return input
    .replace(/\\n/g, '\n')
    .split(SEPARATOR_REGEX)
    .filter(emailValidator);
}

export default parseEmails;
